const prepareFacets = (data) => {
    const searchResult = data?.searchResult || {};

    const filters = searchResult?.filters || {};

    const facets = filters.facets || [];
    return facets;
}

export default prepareFacets;